import React from 'react';
import {
  LocalPharmacy, AccountBalanceWallet, MoreHoriz, HelpOutline,
  SmokingRooms, SwapHoriz, BeachAccess, School, Receipt, Spa,
  SportsSoccer, LocalHospital, ShoppingCart, AttachMoney,
  Coffee, Restaurant, DirectionsCar, Gavel, LocalGasStation, Home,
  Storefront, HealthAndSafety, Favorite, ChildFriendly, Savings,
  Wifi, HomeWork, Security, Water, VolunteerActivism,
  FlashOn, Fireplace, AccountBalance, GroupWork, Devices,
  CardGiftcard, Checkroom, Pool, Commute, MedicalServices, TheaterComedy,
  Elderly, Report, Apps, Pending, TrendingUp,
  DirectionsBike, CreditCard, Work, WorkOutline, ShowChart,
  Subscriptions, Handyman, Shield, Bolt, Balance, Person,
  ElectricCar, TwoWheeler, Hotel, Toll, ConfirmationNumber, CurrencyBitcoin,
  WineBar, Smartphone, SelfImprovement, Newspaper, CleaningServices,
  FactCheck
} from '@mui/icons-material';
import MoneyIcon from '@mui/icons-material/Money';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import CarRepairIcon from '@mui/icons-material/CarRepair';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import PaymentsIcon from '@mui/icons-material/Payments';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import GarageIcon from '@mui/icons-material/Garage';
import { Tooltip, Typography } from '@mui/material';
import { capitalize } from '../../functions/formatString';

// Normalitza cadenes per cerca de clau (majúscules i sense accents)
const normalizeConceptKey = (str) => {
  if (!str || typeof str !== 'string') return '';
  return str
    .trim()
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
};

// Paletes de colors per a fills i néts que hereten o comparteixen icona amb el pare/avi
const CHILD_PALETTE_L2 = ['#00897B', '#5C6BC0', '#E65100', '#43A047', '#00ACC1', '#8E24AA', '#D81B60'];
const CHILD_PALETTE_L3 = ['#7B1FA2', '#1E88E5', '#FB8C00', '#00796B', '#3949AB', '#C2185B', '#689F38'];

const getDifferentiatedColor = (conceptName, level, parentColor) => {
  const palette = level === 3 ? CHILD_PALETTE_L3 : CHILD_PALETTE_L2;
  const hash = Math.abs(
    (conceptName || '').split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
  );
  let chosen = palette[hash % palette.length];
  if (parentColor && chosen.toUpperCase() === parentColor.toUpperCase()) {
    chosen = palette[(hash + 1) % palette.length];
  }
  return chosen;
};

// Mapeo de iconos
const ConcepteIcon = ({
  concept,
  code = null,
  fallback,
  level = 1,
  parentConcept = null,
  tipusNode = null,
  sx,
  onlyIcon = false
}) => {
  const mappings = {
    ALIENS: <ChildFriendlyIcon sx={{ color: "#616161", ...sx }} />,  // General Shopping
    FARMACIA: <LocalPharmacy sx={{ color: "#4CAF50", ...sx }} />,          // Pharmacy
    "ENS HO DEUEN": <AccountBalanceWallet sx={{ color: "#C2185B", ...sx }} />, // "They Owe Us" (Wallet)
    ALTRES: <MoreHoriz sx={{ color: "#9E9E9E", ...sx }} />,                // Others
    "PDT DESGLOSSAR": <HelpOutline sx={{ color: "#FFB300", ...sx }} />,    // To Split (Question Mark)
    "PENDENT-VALIDAR": <FactCheck sx={{ color: "#FB8C00", ...sx }} />,    // Proposta pendent de validar
    PENDENT_VALIDAR: <FactCheck sx={{ color: "#FB8C00", ...sx }} />,
    PEND_VALIDAR: <FactCheck sx={{ color: "#FB8C00", ...sx }} />,
    TABAC: <SmokingRooms sx={{ color: "#795548", ...sx }} />,              // Tobacco
    TRASPASSOS: <SwapHoriz sx={{ color: "#607D8B", ...sx }} />,            // Transfers
    VACANCES: <BeachAccess sx={{ color: "#0288D1", ...sx }} />,            // Vacations
    ESCOLA: <School sx={{ color: "#4CAF50", ...sx }} />,                   // School
    COMISIONS: <Receipt sx={{ color: "#FFB74D", ...sx }} />,               // Commissions
    ESTETICA: <Spa sx={{ color: "#D81B60", ...sx }} />,                    // Aesthetics/Beauty
    EXTRAESCOLARS: <SportsSoccer sx={{ color: "#8E24AA", ...sx }} />,      // Extracurricular Activities
    FRESCOS: <ShoppingBasketIcon sx={{ color: "#1976D2", ...sx }} />,       // Groceries/Fresh Food (Blau)
    METGE: <LocalHospital sx={{ color: "#388E3C", ...sx }} />,             // Doctor/Medical
    SUPER: <ShoppingCart sx={{ color: "#4CAF50", ...sx }} />,              // Supermarket (Verd)
    EFECTIU: <MoneyIcon sx={{ color: "#388E3C", ...sx }} />,             // Cash
    CAFE: <Coffee sx={{ color: "#6D4C41", ...sx }} />,                     // Coffee
    "BAR RESTAURANT": <Restaurant sx={{ color: "#FF7043", ...sx }} />,     // Bar/Restaurant
    "SEGURO VEHICLE": <DirectionsCar sx={{ color: "#03A9F4", ...sx }} />,  // Vehicle Insurance
    IMPOSTOS: <Gavel sx={{ color: "#C2185B", ...sx }} />,                  // Taxes
    GASOLINA: <LocalGasStation sx={{ color: "#FFA000", ...sx }} />,        // Gasoline
    "SEGURO LLAR": <Home sx={{ color: "#607D8B", ...sx }} />,              // Home Insurance
    COMPRES: <Storefront sx={{ color: "#F57C00", ...sx }} />,              // Purchases
    "SEGURO MEDIC": <HealthAndSafety sx={{ color: "#4CAF50", ...sx }} />,  // Medical Insurance
    "SEGURO VIDA": <Favorite sx={{ color: "#D32F2F", ...sx }} />,          // Life Insurance
    CANGUR: <ChildFriendly sx={{ color: "#FFD54F", ...sx }} />,            // Babysitting
    PRESTECS: <CreditScoreIcon sx={{ color: "#FFB74D", ...sx }} />,                // Loans
    HIPOTECA: <CreditScoreIcon sx={{ color: "#FFB74D", ...sx }} />,                // Loans
    INTERNET: <Wifi sx={{ color: "#29B6F6", ...sx }} />,                   // Internet
    "PIS MANRESA": <HomeWork sx={{ color: "#8D6E63", ...sx }} />,          // Apartment in Manresa
    "COMUNITAT PIS": <HomeWork sx={{ color: "#8D6E63", ...sx }} />,          // Apartment in Manresa
    "PLA PENSIONS": <Savings sx={{ color: "#388E3C", ...sx }} />,         // Pension Plan
    AIGUA: <Water sx={{ color: "#0288D1", ...sx }} />,                     // Water
    ALARMA: <Security sx={{ color: "#C2185B", ...sx }} />,            // Alarm System
    CARITAT: <VolunteerActivism sx={{ color: "#FF7043", ...sx }} />,       // Charity
    ELECTRICITAT: <FlashOn sx={{ color: "#FFEB3B", ...sx }} />,            // Electricity
    GAS: <Fireplace sx={{ color: "#FFA000", ...sx }} />,                   // Gas
    "QUOTES ANUALS": <EventRepeatIcon sx={{ color: "#8D6E63", ...sx }} />,  // Annual Fees
    SINDICATS: <GroupWork sx={{ color: "#0288D1", ...sx }} />,             // Unions
    ELECTROS: <Devices sx={{ color: "#8E24AA", ...sx }} />,                // Electronics
    REGALS: <CardGiftcard sx={{ color: "#D32F2F", ...sx }} />,             // Gifts
    ROBA: <Checkroom sx={{ color: "#F57C00", ...sx }} />,                  // Clothes
    "PISCINA-OSMOSIS": <Pool sx={{ color: "#0288D1", ...sx }} />,          // Pool & Osmosis
    TRANSPORT: <Commute sx={{ color: "#795548", ...sx }} />,               // Transport
    DENTISTA: <MedicalServices sx={{ color: "#9E9E9E", ...sx }} />,        // Dentist
    OCI: <TheaterComedy sx={{ color: "#FFC107", ...sx }} />,               // Leisure
    "MANTMENT-COTXES": <CarRepairIcon sx={{ color: "#03A9F4", ...sx }} />,         // Car Maintenance
    AVIS: <Elderly sx={{ color: "#FFD54F", ...sx }} />,                    // Elderly Care
    MULTES: <Report sx={{ color: "#C2185B", ...sx }} />,                   // Fines
    APPS: <Apps sx={{ color: "#607D8B", ...sx }} />,                       // Apps
    PENDENT: <Pending sx={{ color: "#C2185B", ...sx }} />,                 // Pending
    INVERSIONS: <TrendingUp sx={{ color: "#388E3C", ...sx }} />,           // Investments
    "INV-TRASPAS": <SwapHoriz sx={{ color: "#388E3C", ...sx }} />,
    "INV-GUANYS": <ShowChart sx={{ color: "#388E3C", ...sx }} />,
    "MANTMENT-CASA": <HomeRepairServiceIcon sx={{ color: "#8D6E63", ...sx }} />,        // Home Maintenance
    "MANTMENT-MOTO": <DirectionsBike sx={{ color: "#03A9F4", ...sx }} />,  // Motorcycle Maintenance
    INGRES: <AttachMoney sx={{ color: "#4CAF50", ...sx }} />,              // Income
    HISENDA: <AccountBalance sx={{ color: "#FF7043", ...sx }} />,          // Treasury/Tax Authority
    "PREPAGO MERCE": <CreditCard sx={{ color: "#8D6E63", ...sx }} />,      // Prepayment
    "NOMINA MERCE": <Work sx={{ color: "#4CAF50", ...sx }} />,      // Salary (Woman)
    "NOMINA CARLES": <WorkOutline sx={{ color: "#4CAF50", ...sx }} />,            // Salary (Man)
    "DESPESES FEINA": <PaymentsIcon sx={{ color: "#8D6E63", ...sx }} />,        // Work Expenses Reimbursements
    PENSIO: <Elderly sx={{ color: "#0288D1", ...sx }} />,                   // Pension    
    PARKING: <GarageIcon sx={{ color: "#0288D1", ...sx }} />,               // Parking
    "COMUNITAT PARKING": <GarageIcon sx={{ color: "#0288D1", ...sx }} />,   // Cominitat PK
    "INGRES PARKING": <GarageIcon sx={{ color: "#4CAF50", ...sx }} />,   // Cominitat PK
    "INGRES CARLES": <TrendingUp sx={{ color: "#4CAF50", ...sx }} />,   // Cominitat PK
    "INGRES LLOGUER": <Savings sx={{ color: "#388E3C", ...sx }} />,  // Cominitat PK

    // Macroconceptes de Nivell 1 (Arbre Jeràrquic)
    ALIMENTACIO: <ShoppingBasketIcon sx={{ color: "#FB8C00", ...sx }} />,   // Alimentació (N1 - Cistella taronja)
    SUBMINISTRAMENTS: <Bolt sx={{ color: "#FFA000", ...sx }} />,           // Subministraments (N1)
    SALUT: <MedicalServices sx={{ color: "#E53935", ...sx }} />,             // Salut (N1)
    TRIBUTS: <Balance sx={{ color: "#C2185B", ...sx }} />,                   // Tributs (N1)
    SUBSCRIPCIONS: <Subscriptions sx={{ color: "#E91E63", ...sx }} />,       // Subscripcions (N1)
    SUBSCRIPCIO: <Subscriptions sx={{ color: "#E91E63", ...sx }} />,         // Subscripció (N1)
    MANTENIMENT: <Handyman sx={{ color: "#546E7A", ...sx }} />,              // Manteniment (N1)
    SEGURO: <Shield sx={{ color: "#1565C0", ...sx }} />,                     // Assegurances (N1)
    SEGUROS: <Shield sx={{ color: "#1565C0", ...sx }} />,                    // Assegurances (N1)
    ASSEGURANCES: <Shield sx={{ color: "#1565C0", ...sx }} />,               // Assegurances (N1)
    QUOTES: <EventRepeatIcon sx={{ color: "#8D6E63", ...sx }} />,            // Quotes (N1)
    NOMINA: <Work sx={{ color: "#2E7D32", ...sx }} />,                       // Nòmina (N1)
    INVERSIO: <TrendingUp sx={{ color: "#388E3C", ...sx }} />,               // Inversió (N1)
    PIS_MANRESA: <HomeWork sx={{ color: "#8D6E63", ...sx }} />,             // Pis Manresa (N1)
    VEHICLES: <DirectionsCar sx={{ color: "#0288D1", ...sx }} />,           // Vehicles transversal (N1)
    PERSONES: <Person sx={{ color: "#7B1FA2", ...sx }} />,                   // Persones transversal (N1)
    DESPESES: <PaymentsIcon sx={{ color: "#8D6E63", ...sx }} />,             // Despeses genèric (N1)
    INGRESSOS: <AttachMoney sx={{ color: "#4CAF50", ...sx }} />,             // Ingressos genèric (N1)
    FINANCES: <AccountBalance sx={{ color: "#3F51B5", ...sx }} />,           // Finances (N1)

    // Vehicles concrets: icones i colors distintius per a cadascun
    TARRACO: <DirectionsCar sx={{ color: "#1565C0", ...sx }} />,            // Tarraco (blau marí intens)
    ID4: <ElectricCar sx={{ color: "#00897B", ...sx }} />,                  // ID4 (turquesa elèctric)
    I10: <DirectionsCar sx={{ color: "#FB8C00", ...sx }} />,                // i10 (ambre taronja)
    MOTO: <TwoWheeler sx={{ color: "#E53935", ...sx }} />,                  // Moto (moto vermella)
    TOYOTA: <DirectionsCar sx={{ color: "#C62828", ...sx }} />,              // Toyota (vermell fosc)
    LEON: <DirectionsCar sx={{ color: "#7B1FA2", ...sx }} />,                // Leon (morat)
    INDETERMINAT: <DirectionsCar sx={{ color: "#78909C", ...sx }} />,        // Indeterminat (gris neutre)
    INDET: <DirectionsCar sx={{ color: "#78909C", ...sx }} />,

    // Persones concretes: colors distintius per a cadascuna
    CARLITUS: <Person sx={{ color: "#1976D2", ...sx }} />,                  // Carlitus / Carles (blau)
    CARLES: <Person sx={{ color: "#1976D2", ...sx }} />,
    GUAPI: <Person sx={{ color: "#D81B60", ...sx }} />,                     // Guapi / Merce (rosa fúcsia)
    MERCE: <Person sx={{ color: "#D81B60", ...sx }} />,
    JOANA: <Person sx={{ color: "#8E24AA", ...sx }} />,                     // Joana (morat)
    QUERALT: <Person sx={{ color: "#00897B", ...sx }} />,                   // Queralt (turquesa)
    MARTI: <Person sx={{ color: "#F57C00", ...sx }} />,                     // Marti (taronja)
    "ALTRES PERSONES": <Person sx={{ color: "#9E9E9E", ...sx }} />,

    // Subconceptes freqüents
    PEATGES: <Toll sx={{ color: "#EF6C00", ...sx }} />,                     // Peatges (taronja peatge)
    BITLLETS: <ConfirmationNumber sx={{ color: "#1565C0", ...sx }} />,      // Bitllets (blau bitllet)
    HOTEL: <Hotel sx={{ color: "#5C6BC0", ...sx }} />,                      // Hotel (indi)
    ENTRADES: <ConfirmationNumber sx={{ color: "#AB47BC", ...sx }} />,       // Entrades (lila)
    "LLOGUER COTXE": <DirectionsCar sx={{ color: "#00897B", ...sx }} />,    // Lloguer cotxe (turquesa)
    CONSUMICIO: <Coffee sx={{ color: "#6D4C41", ...sx }} />,                // Consumició (cafè)
    APAT: <Restaurant sx={{ color: "#FF7043", ...sx }} />,                  // Àpat (restaurant)
    CLASIFICAR: <Pending sx={{ color: "#C2185B", ...sx }} />,               // Pendent classificar
    DESGLOSAR: <HelpOutline sx={{ color: "#FFB300", ...sx }} />,            // Pendent desglossar
    COMPRA: <TrendingUp sx={{ color: "#2E7D32", ...sx }} />,                // Compra inversió
    SP500: <ShowChart sx={{ color: "#1565C0", ...sx }} />,                  // S&P 500
    GOLD: <Savings sx={{ color: "#FFB300", ...sx }} />,                     // Or
    BITCOIN: <CurrencyBitcoin sx={{ color: "#F7931A", ...sx }} />,          // Cripto
    CASA: <Home sx={{ color: "#8D6E63", ...sx }} />,                        // Casa
    PISCINA: <Pool sx={{ color: "#0288D1", ...sx }} />,                     // Piscina
    LLAR: <Home sx={{ color: "#607D8B", ...sx }} />,                        // Llar assegurança
    VIDA: <Favorite sx={{ color: "#D32F2F", ...sx }} />,                    // Vida assegurança
    ANUALS: <EventRepeatIcon sx={{ color: "#8D6E63", ...sx }} />,           // Subscripcions anuals
    MENSUALS: <Subscriptions sx={{ color: "#5C6BC0", ...sx }} />,          // Subscripcions mensuals

    // Codis jeràrquics oficials (107 codis complets)
    ALIM_CAFE: <Coffee sx={{ color: "#6D4C41", ...sx }} />,
    ALIM_FRESCOS: <ShoppingBasketIcon sx={{ color: "#1976D2", ...sx }} />,
    ALIM_SUPER: <ShoppingCart sx={{ color: "#4CAF50", ...sx }} />,
    ALIM_VI: <WineBar sx={{ color: "#8E24AA", ...sx }} />,
    AVIS_SANT_BOI: <Elderly sx={{ color: "#FFA000", ...sx }} />,
    AVIS_SILVIA: <Elderly sx={{ color: "#FB8C00", ...sx }} />,
    BAR_APAT: <Restaurant sx={{ color: "#FF7043", ...sx }} />,
    BAR_CONSUMICIO: <Coffee sx={{ color: "#6D4C41", ...sx }} />,
    "CANG-NETEJA": <CleaningServices sx={{ color: "#00ACC1", ...sx }} />,
    CANG_NETEJA: <CleaningServices sx={{ color: "#00ACC1", ...sx }} />,
    COMP_ALTRES: <Storefront sx={{ color: "#F57C00", ...sx }} />,
    COMP_APPS: <Apps sx={{ color: "#607D8B", ...sx }} />,
    COMP_ELECTROS: <Devices sx={{ color: "#8E24AA", ...sx }} />,
    COMP_ROBA: <Checkroom sx={{ color: "#F57C00", ...sx }} />,
    DESPESES_FEINA: <PaymentsIcon sx={{ color: "#8D6E63", ...sx }} />,
    ENT_PER_ALTRES: <Person sx={{ color: "#9E9E9E", ...sx }} />,
    ENT_PER_CARLITUS: <Person sx={{ color: "#1976D2", ...sx }} />,
    ENT_PER_GUAPI: <Person sx={{ color: "#D81B60", ...sx }} />,
    ENT_PER_JOANA: <Person sx={{ color: "#8E24AA", ...sx }} />,
    ENT_PER_MARTI: <Person sx={{ color: "#F57C00", ...sx }} />,
    ENT_PER_QUERALT: <Person sx={{ color: "#00897B", ...sx }} />,
    ENT_VEH_I10: <DirectionsCar sx={{ color: "#FB8C00", ...sx }} />,
    ENT_VEH_ID4: <ElectricCar sx={{ color: "#00897B", ...sx }} />,
    ENT_VEH_INDET: <DirectionsCar sx={{ color: "#78909C", ...sx }} />,
    ENT_VEH_LEON: <DirectionsCar sx={{ color: "#7B1FA2", ...sx }} />,
    ENT_VEH_MOTO: <TwoWheeler sx={{ color: "#E53935", ...sx }} />,
    ENT_VEH_TARRACO: <DirectionsCar sx={{ color: "#1565C0", ...sx }} />,
    ENT_VEH_TOYOTA: <DirectionsCar sx={{ color: "#C62828", ...sx }} />,
    INV_ALTRES: <TrendingUp sx={{ color: "#388E3C", ...sx }} />,
    INV_BITCOIN: <CurrencyBitcoin sx={{ color: "#F7931A", ...sx }} />,
    INV_COMPRA: <TrendingUp sx={{ color: "#2E7D32", ...sx }} />,
    INV_GOLD: <Savings sx={{ color: "#FFB300", ...sx }} />,
    INV_GUANYS: <ShowChart sx={{ color: "#388E3C", ...sx }} />,
    INV_SP500: <ShowChart sx={{ color: "#1565C0", ...sx }} />,
    INV_TRASPAS: <SwapHoriz sx={{ color: "#388E3C", ...sx }} />,
    MANT_CASA: <HomeRepairServiceIcon sx={{ color: "#8D6E63", ...sx }} />,
    MANT_PISCINA: <Pool sx={{ color: "#0288D1", ...sx }} />,
    MANT_VEHICLES: <CarRepairIcon sx={{ color: "#03A9F4", ...sx }} />,
    PEND_CLASIFICAR: <Pending sx={{ color: "#C2185B", ...sx }} />,
    PEND_DESGLOSAR: <HelpOutline sx={{ color: "#FFB300", ...sx }} />,
    PEND_ENS_HO_DEUEN: <AccountBalanceWallet sx={{ color: "#C2185B", ...sx }} />,
    PREST_CASA: <CreditScoreIcon sx={{ color: "#FFB74D", ...sx }} />,
    PREST_COTXE: <CreditScoreIcon sx={{ color: "#03A9F4", ...sx }} />,
    QUOTES_ALTRES: <EventRepeatIcon sx={{ color: "#9E9E9E", ...sx }} />,
    QUOTES_CARITAT: <VolunteerActivism sx={{ color: "#FF7043", ...sx }} />,
    QUOTES_SINDICATS: <GroupWork sx={{ color: "#0288D1", ...sx }} />,
    SAL_ALTRES: <MedicalServices sx={{ color: "#9E9E9E", ...sx }} />,
    SAL_DENTISTA: <MedicalServices sx={{ color: "#00897B", ...sx }} />,
    SAL_FARMACIA: <LocalPharmacy sx={{ color: "#4CAF50", ...sx }} />,
    SAL_FISIO: <SelfImprovement sx={{ color: "#3949AB", ...sx }} />,
    SAL_METGE: <LocalHospital sx={{ color: "#388E3C", ...sx }} />,
    SEG_LLAR: <Home sx={{ color: "#607D8B", ...sx }} />,
    SEG_MEDIC: <HealthAndSafety sx={{ color: "#4CAF50", ...sx }} />,
    SEG_VEHICLES: <DirectionsCar sx={{ color: "#03A9F4", ...sx }} />,
    SEG_VIDA: <Favorite sx={{ color: "#D32F2F", ...sx }} />,
    SUB_AIGUA: <Water sx={{ color: "#0288D1", ...sx }} />,
    SUB_ALARMA: <Security sx={{ color: "#C2185B", ...sx }} />,
    SUB_ALTRES_SUBS: <Subscriptions sx={{ color: "#9E9E9E", ...sx }} />,
    SUB_AMAZON: <ShoppingCart sx={{ color: "#FF9900", ...sx }} />,
    SUB_ANUALS: <EventRepeatIcon sx={{ color: "#8D6E63", ...sx }} />,
    SUB_ELEC: <FlashOn sx={{ color: "#FFEB3B", ...sx }} />,
    SUB_GAS: <Fireplace sx={{ color: "#FFA000", ...sx }} />,
    SUB_GOOGLE: <Apps sx={{ color: "#4285F4", ...sx }} />,
    SUB_INTERNET: <Wifi sx={{ color: "#29B6F6", ...sx }} />,
    SUB_MENSUALS: <Subscriptions sx={{ color: "#5C6BC0", ...sx }} />,
    SUB_MOVIL: <Smartphone sx={{ color: "#0288D1", ...sx }} />,
    SUB_VANGUARDIA: <Newspaper sx={{ color: "#1E88E5", ...sx }} />,
    TR_BITLLETS: <ConfirmationNumber sx={{ color: "#1565C0", ...sx }} />,
    TR_PARKING: <GarageIcon sx={{ color: "#0288D1", ...sx }} />,
    TR_PEATGES: <Toll sx={{ color: "#EF6C00", ...sx }} />,
    TRIB_HISENDA: <AccountBalance sx={{ color: "#FF7043", ...sx }} />,
    TRIB_IMPOSTOS: <Gavel sx={{ color: "#C2185B", ...sx }} />,
    TRIB_MULTES: <Report sx={{ color: "#C2185B", ...sx }} />,
    VAC_HOTEL: <Hotel sx={{ color: "#5C6BC0", ...sx }} />,
    VAC_LLOGUER_COTXE: <DirectionsCar sx={{ color: "#00897B", ...sx }} />
  };

  const lookupCode = code ? String(code).trim().toUpperCase() : null;
  const lookupConcept = concept ? String(concept).trim().toUpperCase() : null;
  const normConcept = normalizeConceptKey(concept);

  // 1. Resolució directa pel CODI oficial de la BBDD (sense normalitzacions de text)
  let iconElement = 
    (lookupCode && mappings[lookupCode]) ||
    (lookupConcept && mappings[lookupConcept]) ||
    mappings[normConcept] ||
    mappings[concept];

  let isFromFallback = false;

  // Fallback específic segons tipusNode si no té mapping propi
  if (!iconElement && tipusNode === 'VEHICLE') {
    iconElement = mappings[normConcept] || <DirectionsCar sx={{ color: level === 3 ? "#5C6BC0" : "#00ACC1", ...sx }} />;
  } else if (!iconElement && tipusNode === 'PERSONA') {
    iconElement = mappings[normConcept] || <Person sx={{ color: level === 3 ? "#4A148C" : "#AD1457", ...sx }} />;
  }

  // Fallback a concepte clàssic o al concepte pare/avi
  if (!iconElement && fallback) {
    const fallbacks = Array.isArray(fallback) ? fallback : [fallback];
    for (const fb of fallbacks) {
      if (!fb) continue;
      const normFb = normalizeConceptKey(fb);
      const upperFb = typeof fb === 'string' ? fb.toUpperCase() : '';
      if (mappings[normFb] || mappings[upperFb] || mappings[fb]) {
        iconElement = mappings[normFb] || mappings[upperFb] || mappings[fb];
        isFromFallback = true;
        break;
      }
    }
  }

  if (!iconElement) {
    iconElement = <AttachMoney sx={{ color: "#9E9E9E", ...sx }} />;
  }

  // Si el fill té la mateixa icona que el seu pare o avi (per fallback o per tipus) i level > 1,
  // canviem el color del fill perquè sigui diferenciat del pare/avi:
  if (level > 1 && parentConcept) {
    const normParent = normalizeConceptKey(parentConcept);
    const parentIcon = mappings[normParent] || mappings[parentConcept?.toUpperCase?.()] || mappings[parentConcept];
    const sameIconAsParent = isFromFallback || (parentIcon && parentIcon.type === iconElement.type);

    if (sameIconAsParent) {
      const parentColor = parentIcon?.props?.sx?.color;
      const currentColor = iconElement.props?.sx?.color;
      if (!currentColor || !parentColor || currentColor.toUpperCase() === parentColor.toUpperCase()) {
        const diffColor = getDifferentiatedColor(concept, level, parentColor);
        iconElement = React.cloneElement(iconElement, {
          sx: { ...iconElement.props?.sx, color: diffColor, ...sx }
        });
      }
    }
  }

  if (onlyIcon) {
    return iconElement;
  }

  return (
    <>
      {iconElement}
      <Typography variant="small">{capitalize(concept)}</Typography>
    </>
  );
};

const TipusMovIcon = ({ tipus, sx }) => {
  const mappings = {
    TARGETA: <CreditCard sx={{ color: "#616161", ...sx }} />,
    COMPTE: <AccountBalance sx={{ color: "#4CAF50", ...sx }} />,
  };

  return (
    <Tooltip title={tipus}>
      {mappings[tipus] || <AttachMoney sx={{ color: "#9E9E9E", ...sx }} />}
    </Tooltip>
  );
};

export { ConcepteIcon, TipusMovIcon };
